<template>
    <div class="adContract">
        <div class="content">
            <van-field
                v-model="orderNumber"
                clearable
                label-width= 90
                label="订单号"
                readonly
                size="medium"
                class="inputVant"
            />
            <van-field
                label="报修原因"
                label-width= 90
                placeholder="损毁"
                readonly
                class="inputVant"
            />
            <van-field
                label="期望上门时间"
                label-width= 90
                v-model="time"
                placeholder="YYYY-MM-DD"
                class="inputVant"
                readonly
                @click="setData()"
            />
            <van-field
                label="详细描述"
                label-width= 90
                type="textarea"
                :autosize= autoSize
                placeholder="详细描述"
                v-model="remake"
                class="textareaVant"
                
            />
        </div>
        <div class="pickerModel">
            <van-datetime-picker
            v-if="tiemShow"
            v-model="currentDate"
            type="date"
            @cancel="hidePicker"
            @confirm="confirms" 
            />
        </div>
        <div class="imgList flex-row">
            <p class="imgTitle">上传图片：</p>
            <van-uploader class="imgItem" :after-read="afterRead" :max-count="3" v-model="imgList"/>
        </div>
        <div class="Submission" @click="submit()">提 交</div>
    </div>
</template>
<script>
import { Field, CellGroup, DatetimePicker, Uploader, Notify } from 'vant';
import { put } from '@/utils/auth.js';
import { addQuestionnaire } from '@/api/index';
export default {
    components:{
        [Field.name] : Field,
        [CellGroup.name] : CellGroup,
        [DatetimePicker.name] : DatetimePicker,
        [Uploader.name] : Uploader,
        [Notify.name] : Notify
    },
    created(){
        this.orderNumber = this.$route.query.item.orderNumber;
    },
    data(){
        return {
            currentDate: new Date(),//生成时间对象
            orderNumber:'',//订单号
            time:'',//回显选择时间
            autoSize:{maxHeight: 100, minHeight: 100}, //picker样式配置
            tiemShow: false,//弹框show变量
            imgList:[],//图片回显数据
            remake: '',//备注
            imgName: []
        }
    },
    methods:{
        /**
         * 显示时间选择器
         * @method setData
         */
        setData(){
            this.tiemShow = true;
        },
        /**
         * 关闭时间选择器
         * @method hidePicker
         */
        hidePicker(){
            this.tiemShow = false;
        },
        /**
         * 时间选择器change时间
         * @method confirms
         */
        confirms(item){
            this.tiemShow = false;
            const d = new Date(item);
            const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
            const resTime = this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds())
            console.log(resTime)
            this.time = `${resDate}`;
        },
        p(s) {
            return s < 10 ? '0' + s : s
        },
        /**
         * 上传图片
         * @methods afterRead
         */
        afterRead(res) {
        // 此时可以自行将文件上传至服务器
            put(res).then(data => {
                console.log(res);
                Notify({
                message: '图片上传成功',
                duration: 1000,
                background: '#1989fa'
                });
                this.imgName.unshift(data.name);
                if (this.imgName.length > 3) {
                    this.imgName.pop();
                }
            });
        },
        submit(){
            let data ={
                // dictId (integer, optional): '损坏' ,
                // expectedVisitTime (string, optional): this.time ,
                // orderId: this.$route.query.item.orderNumber ,
                // phone (string, optional): 登录人手机号 ,
                // questionnaireNumber (string, optional): 问题编号 ,
                // remake (string, optional): this.remake ,
                // tarNames (string, optional): this.imgName.join(','),
            }
            addQuestionnaire({data}).then(res=> {
                Notify({
                    message: '新增报修成功',
                    duration: 1000,
                    background: '#1989fa'
                });
                this.$route.push({path:'/order'});
            }).catch(error => {
                Notify({
                    message: '新增报修失败',
                    duration: 1000,
                    background: '#1989fa'
                });
                this.$route.push({path:'/order'});
            })

        }
    }
    
}
</script>
<style lang="scss" scoped>
.adContract{
    width: 100vw;
    height: 100%;
    position: relative;
    background-color: #f6f6f6;
    .content{
        background: #ffffff;
        padding: 0 33px 0 43px;
        .inputVant{
            line-height: 71px;
            align-items:center;
        }
        .textareaVant{
            padding-top: 20px;
            line-height: 34px;
        }
    } 
    .pickerModel{
        position: fixed;
        bottom: 0;
        width: 100vw;
    }
    .imgList{
        background: #ffffff;
        padding: 20px 33px 20px 43px;
        border-top:1px solid  #f6f6f6;
        .imgTitle{
            margin-left: 14px;
            margin-right: 20px; 
        }
    }
    .Submission{
        margin: 40px 20px 0 20px;
        height:82px;
        background:rgba(248,169,31,1);
        border-radius:15px;
        color: rgba(254, 254, 254, 1);
        font-size:36px;
        line-height: 82px;
        text-align: center;
    }
}
</style>


